import { useEffect, useState } from 'react';
import { DataPackageV2Component } from '@vivli/shared/features/data-package/components';
import { IDataPackageFileDescriptor } from '@vivli/shared/features/data-package/infrastructure/interface';
import { LoggerService } from '@vivli/shared/infrastructure/service';
import { useChatApiContext } from '@vivli/core/infrastructure/context';

interface ChatDataPackageFeatureProps {
    chatChannelId: string;
    allowUpload: boolean;
    showFileWarning: boolean;
    showChatUploadFileWarning: boolean;
    onFileAdded?: (file: IDataPackageFileDescriptor) => void;
    onFileRemoved?: (file: IDataPackageFileDescriptor) => void;
}

export const ChatDataPackageFeature = ({
    chatChannelId,
    allowUpload,
    onFileAdded,
    showFileWarning,
    showChatUploadFileWarning,
    onFileRemoved,
}: ChatDataPackageFeatureProps) => {
    const [dataPackageId, setDataPackageId] = useState(null);
    const chatService = useChatApiContext();

    useEffect(() => {
        if (!chatChannelId) {
            return;
        }
        //retrieve the data only when chat is active
        const sub = chatService.getChatChannel(chatChannelId).subscribe((result) => {
            if (result) {
                LoggerService.info(`Files are retrieved for the channel ${chatChannelId}.`);
                setDataPackageId(result.channel.attachmentsDataPackageId);
            }
        });

        return () => {
            sub.unsubscribe();
        };
    }, [chatChannelId]);

    if (!chatChannelId) {
        return <div>{!chatChannelId && <span>This chat package is restricted or is unavailable.</span>}</div>;
    }
    return (
        <DataPackageV2Component
            dataPackageId={dataPackageId}
            readOnly={false}
            allowDownload={true}
            allowUpload={allowUpload}
            allowDelete={true}
            allowSubmit={false}
            hideFileType={true}
            showUploadDate={true}
            onFileAdded={onFileAdded}
            onFileRemoved={onFileRemoved}
            miniature={true}
            showChatUploadFileWarning={showChatUploadFileWarning}
            showFileWarning={showFileWarning}
            showExpandedFilename={false}
            sortFilesByDate={true}
            showDeleteDialog={true}
            showVerifyButton={true}
            hideSize={true}
            availableTypes={['Study Protocol', 'CSR', 'Other', 'Unknown']}
            title="Uploaded Files"
        />
    );
};
